module.exports = __webpack_public_path__ + "static/img/3_v2.d724b2c0.png";